import { format } from "date-fns";

class ProductUtil {
    static transform(product) {
        let productPrices = [];
        if (product.prices && product.prices.length > 0) {
            product.prices.forEach(i =>
                productPrices.push({
                    productPriceId: i.productPriceId,
                    price: i.price,
                    startDate: i.startDate,
                    endDate: i.endDate,
                    fromQuantity: i.fromQuantity,
                    defaultDiscount: i.defaultDiscount,
                    productPriceTypeId: i.productPriceType
                        ? i.productPriceType.productPriceTypeId
                        : i.productPriceTypeId || "",
                    mrp: i.mrp
                })
            );
        }

        let productAttributes = [];
        if (product.productAttributes && product.productAttributes.length > 0) {
            productAttributes = product.productAttributes.map(i => ({
                attributeId: i.attributeId,
                productAttributeId: i.productAttributeId,
                value: i.productAttributeValue
                    ? i.productAttributeValue.value
                    : i.value || "",
                productAttributeValueId: i.productAttributeValue
                    ? i.productAttributeValue.productAttributeValueId
                    : i.productAttributeValueId || ""
            }));
        }

        return {
            productId: product.productId,
            name: product.name,
            purchasePrice: product.purchasePrice,
            taxId: product.taxId,
            unitId: product.unitId,
            minimumQuantity: product.minimumQuantity ? product.minimumQuantity : 1,
            hsn: product.hsn,
            barcode: product.barcode,
            isDisabled: product.isDisabled ? product.isDisabled : false,
            quantity: product.quantity ? product.quantity : 0,
            mrp: product.mrp,
            tax: product.tax || null,
            prices:
                productPrices.length > 0
                    ? productPrices
                    : [
                          {
                              startDate: format(new Date(), "YYYY-MM-DD"),
                              price: 0,
                              fromQuantity: 1,
                              defaultDiscount: null
                          }
                      ],
            productAttributes:
                productAttributes.length > 0
                    ? productAttributes
                    : [
                          {
                              attributeId: "",
                              value: ""
                          }
                      ],
            metadata: product.metadata
        };
    }
}

export default ProductUtil;